"use strict";function checkInstalledApps$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.checkInstalledApps$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.launcher.checkInstalledApps";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.checkInstalledApps$=checkInstalledApps$,exports.default=checkInstalledApps$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/launcher/checkInstalledApps.js
// module id = 1062
// module chunks = 106